export const APP_CONFIG = {
  environment: 'PRD', // Cambiar a 'PRD' en producción

  sharePoint: {
    environments: {
      PRU: {
        webUrl: 'https://prucorporativo.compensar.com/salud',
        enableLeadSend: false,
      },
      DEV: {
        webUrl: 'https://devcorporativogarzon.compensar.com/salud',
        enableLeadSend: false,
      },
      PRD: {
        webUrl: 'https://corporativo.compensar.com/salud',
        enableLeadSend: true,
      },
    },
  },

  salesforce: {
    environments: {
      PRU: {
        webToLeadUrl:
          'https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00DVC000006UPvB',
        orgId: '00DVC000006UPvB',
        retUrls: {
          default: '',
          beneficios:
            'https://prucorporativo.compensar.com/salud/salud-compensar/Paginas/formularios-registro-interesados/Formulario-Registro-Interesados.aspx?plan=beneficios',
          complementario:
            'https://prucorporativo.compensar.com/salud/salud-compensar/Paginas/formularios-registro-interesados/Formulario-Registro-Interesados.aspx?plan=complementario',
          vital:
            'https://prucorporativo.compensar.com/salud/salud-compensar/Paginas/formularios-registro-interesados/Formulario-Registro-Interesados.aspx?plan=vital',
        },
        fields: {
          tipoDocumento: '00N2G00000CpToT',
          numeroDocumento: '00N2G00000CpToL',
          medioEmail: '00N2G00000B70xl',
          medioCelular: '00N2G00000B70xm',
          medioWhatsapp: '00NUj000005e6DV',
          autorizacion: '00N2G00000B70xn',
          origen: '00N2G00000B6OMv',
          subOrigen: '00N2G00000B6ON1',
          tipoCliente: '00N2G00000B6ON2',
          categoriaPlan: '00NVC000005FN7t',
          tipoPvos: '00NUv000001Qjdd',
        },
      },
      DEV: {
        webToLeadUrl:
          'https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00DVC000006UPvB',
        orgId: '00DVC000006UPvB',
        retUrls: {
          default: '',
          beneficios:
            'https://devcorporativogarzon.compensar.com/salud/salud-compensar/Paginas/formularios-registro-interesados/Formulario-Registro-Interesados.aspx?plan=beneficios',
          complementario:
            'https://devcorporativogarzon.compensar.com/salud/salud-compensar/Paginas/formularios-registro-interesados/Formulario-Registro-Interesados.aspx?plan=complementario',
          vital:
            'https://devcorporativogarzon.compensar.com/salud/salud-compensar/Paginas/formularios-registro-interesados/Formulario-Registro-Interesados.aspx?plan=vital',
        },
        fields: {
          tipoDocumento: '00N2G00000CpToT',
          numeroDocumento: '00N2G00000CpToL',
          medioEmail: '00N2G00000B70xl',
          medioCelular: '00N2G00000B70xm',
          medioWhatsapp: '00NUj000005e6DV',
          autorizacion: '00N2G00000B70xn',
          origen: '00N2G00000B6OMv',
          subOrigen: '00N2G00000B6ON1',
          tipoCliente: '00N2G00000B6ON2',
          categoriaPlan: '00NVC000005FN7t',
          tipoPvos: '00NUv000001Qjdd',
        },
      },
      PRD: {
        webToLeadUrl:
          'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00D6A000001UfII',
        orgId: '00D6A000001UfII',
        retUrls: {
          default: '',
          beneficios:
            'https://corporativo.compensar.com/salud/Paginas/register-form/Formulario-Registro-Interesados.aspx?plan=beneficios',
          complementario:
            'https://corporativo.compensar.com/salud/Paginas/register-form/Formulario-Registro-Interesados.aspx?plan=complementario',
          vital:
            'https://corporativo.compensar.com/salud/Paginas/register-form/Formulario-Registro-Interesados.aspx?plan=vital',
        },
        fields: {
          tipoDocumento: '00N2G00000CpToT',
          numeroDocumento: '00N2G00000CpToL',
          medioEmail: '00N2G00000B70xl',
          medioCelular: '00N2G00000B70xm',
          medioWhatsapp: '00NUj000005e6DV',
          autorizacion: '00N2G00000B70xn',
          origen: '00N2G00000B6OMv',
          subOrigen: '00N2G00000B6ON1',
          tipoCliente: '00N2G00000B6ON2',
          categoriaPlan: '00NVC000005FN7t',
          tipoPvos: '00NUv000001Qjdd',
        },
      },
    },

    recordType: '0122G000001DdTn',
    leadSource: 'Pagina Web',
  },
};